// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-security-reset securityReset-button\"> <i class=\"fa fa-lock\"></i> <!-- ko text: _labels.RESET_SECURITY --><!-- /ko --> </a>";
// Exports
export default code;